/* import __COLOCATED_TEMPLATE__ from './list-section.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();